import { Platform } from "react-native";

export function injectMapboxStyles() {
  if (Platform.OS === "web") {
    // Web-specific implementation
    try {
      const mapboxStyles =
        require("!!raw-loader!mapbox-gl/dist/mapbox-gl.css").default;
      const style = document.createElement("style");
      style.textContent = mapboxStyles;
      document.head.appendChild(style);
    } catch (error) {
      console.warn("Failed to inject Mapbox styles:", error);
    }
  } else {
    // Native platforms don't need CSS injection
    // Mapbox GL Native handles styling differently
    return;
  }
}
